import {App} from "./App";
import {PageView} from "./enums/PageView";

export class AppState {

    page: number;
    app: App;
    appData: any;
    pageView: PageView;
    message: string;
    hasSuccessPurchase: boolean;
    allowBack: boolean;
    showAppInfo: boolean;
    uniqueIds: Array<{key: string, value: string}>;
    paymentDetails: Array<{key: string, value: string}>;
    messageItems: Array<string>;
    actionMessage: string;

    constructor(page: number, app: App, appData: any, pageView: PageView, message?: string,
                uniqueIds?: Array<{key: string, value: string}>, paymentDetails?: Array<{key: string, value: string}>,
                messageItems?: Array<string>, actionMessage?: string) {
        this.page = page;
        this.app = app;
        this.appData = appData;
        this.pageView = pageView;
        this.message = message ?  message : "";
        this.hasSuccessPurchase = false;
        this.allowBack = false;
        this.showAppInfo = false;
        this.uniqueIds = uniqueIds ? uniqueIds : [];
        this.paymentDetails = paymentDetails ? paymentDetails : [];
        this.messageItems = messageItems ? messageItems : [];
        this.actionMessage = actionMessage ? actionMessage : "";
    }

}
